export default __webpack_public_path__ + "static/media/GrabOn.d8c56021.png";